var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-404"},[_vm._v("\n    Hello CSP Test\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }